<script setup lang="ts">
import { resolveComponent } from 'vue'
import type { CmsBlockImageText } from '@shopware/composables'

const props = defineProps<{
    content: CmsBlockImageText
}>()

const { getCmsSlot, getCmsElementName } = useCms()
const leftSlot = computed(() => getCmsSlot(props.content, 'left'))
const rightSlot = computed(() => getCmsSlot(props.content, 'right'))
</script>

<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
            <component
                :is="resolveComponent(getCmsElementName(leftSlot?.type))"
                v-if="leftSlot"
                :content="leftSlot"
            />
        </div>
        <div>
            <component
                :is="resolveComponent(getCmsElementName(rightSlot?.type))"
                v-if="rightSlot"
                :content="rightSlot"
            />
        </div>
    </div>
</template>